<script>
import axios from 'axios'

var uiDomain = process.env.uiDomain
var localDomain = process.env.localDomain
var ossDomain = process.env.ossDomain
var appId = process.env.appId
var wsDomain = process.env.wsDomain
var matchDomain = process.env.matchDomain
var matchUrl = process.env.matchUrl
//存入
if (localStorage.getItem('user_access_token') == null
  || localStorage.getItem('user_access_token') == ''
  || localStorage.getItem('user_access_token') == undefined
  || localStorage.getItem('user_access_token') == 'undefined'
) {
  localStorage.setItem('user_access_token', process.env.user_access_token)
}

if (localStorage.getItem('client_access_token') == null
  || localStorage.getItem('client_access_token') == ''
  || localStorage.getItem('client_access_token') == undefined
  || localStorage.getItem('client_access_token') == 'undefined'
) {
  localStorage.setItem('client_access_token', process.env.client_access_token)
}

if (localStorage.getItem('id') == null
  || localStorage.getItem('id') == ''
  || localStorage.getItem('id') == undefined
  || localStorage.getItem('id') == 'undefined'
) {
  localStorage.setItem('id', process.env.id)
}


function checkWeiXin() {
  var code = 0   //  压力测试用，取消在微信浏览器打开的提示
  if (code == 1) {
    return true
  } else {
    var ua = navigator.userAgent.toLowerCase()
    var isWeixin = ua.indexOf('micromessenger') != -1
    if (isWeixin) {
      return true
    } else {
      return false
    }
  }

}

// 升序排列
function compareAsc(name, minor) {
  return function (o, p) {
    var a, b
    if (o && p && typeof o === 'object' && typeof p === 'object') {
      a = o[name]
      b = p[name]
      if (a === b) {
        return typeof minor === 'function' ? minor(o, p) : 0
      }
      if (typeof a === typeof b) {
        return a < b ? -1 : 1
      }
      return typeof a < typeof b ? -1 : 1
    } else {
      thro("error")
    }
  }
}

// 降序排列
function compareDesc(name, minor) {
  return function (o, p) {
    var a, b
    if (o && p && typeof o === 'object' && typeof p === 'object') {
      a = o[name]
      b = p[name]
      if (a === b) {
        return typeof minor === 'function' ? minor(o, p) : 0
      }
      if (typeof a === typeof b) {
        return a > b ? -1 : 1
      }
      return typeof a > typeof b ? -1 : 1
    } else {
      thro("error")
    }
  }
}

//日期格式化
function dateFtt(fmt, date) { //author: meizz
  var o = {
    "M+": date.getMonth() + 1,                 //月份
    "d+": date.getDate(),                    //日
    "h+": date.getHours(),                   //小时
    "m+": date.getMinutes(),                 //分
    "s+": date.getSeconds(),                 //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    "S": date.getMilliseconds()             //毫秒
  }
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length))
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)))
  return fmt
}

//获取用户角色
function getUserInfo() {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('user_access_token')
  axios.post(localDomain + '/api/user/getUserInfo')
    .then(function (res) {
      return res.data.data
    })
}
function showSchoolName(SchoolObj) {
  if (SchoolObj == null || SchoolObj.constructor !== Object) {
    return ''
  } else {
    // 认证通过
    if (SchoolObj.auth_status == 1) {
      // 设置了品牌
      if (SchoolObj.nickname != null && SchoolObj.brand_id != null && (SchoolObj.brand || SchoolObj.brand_name)) {
        if (SchoolObj.brand) {
          return SchoolObj.brand.name + '·' + SchoolObj.nickname
        } else {
          return SchoolObj.brand_name + '·' + SchoolObj.nickname
        }
      } else {
        return SchoolObj.nickname != null ? SchoolObj.nickname : SchoolObj.name
      }
    } else {//认证未通过， 直接显示全称
      return SchoolObj.name
    }
  }
}
function Nickname(SchoolObj) {
  if (SchoolObj == null || SchoolObj.constructor !== Object) {
    return ''
  } else {
    if (SchoolObj.nickname != null) {
      return SchoolObj.nickname
    } else {
      return SchoolObj.name
    }
  }
}

//过滤用户角色
/**
 * filter(['ZGGZ','FGGZ'])
 */
function filterRole(not_in_roles, url = "http://ui.huabaohui.com") {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('user_access_token')
  axios.post(localDomain + '/api/user/getUserInfo', { schoolId: localStorage.getItem('current_school_id') })
    .then(function (res) {
      var index = -1
      if (res.data.data.has_ZGGZ) {
        index = not_in_roles.indexOf('ZGGZ')
      } else if (res.data.data.has_FGGZ) {
        index = not_in_roles.indexOf('FGGZ')
      } else if (res.data.data.has_LS) {
        index = not_in_roles.indexOf('LS')
      } else if (res.data.data.has_JZ) {
        index = not_in_roles.indexOf('JZ')
      } else if (res.data.data.has_ZJ) {
        index = not_in_roles.indexOf('ZJ')
      } else if (res.data.data.has_KF) {
        index = not_in_roles.indexOf('KF')
      } else {

      }
      // if(index == -1) {
      //     window.location.href = url;
      // }
    })
}
function utf16toEntities(str) { //检测utf16emoji表情 转换为实体字符以供后台存储
  var patt = /[\ud800-\udbff][\udc00-\udfff]/g
  str = str.replace(patt, function (char) {
    var H, L, code
    if (char.length === 2) {   //辅助平面字符（我们需要做处理的一类）
      H = char.charCodeAt(0) // 取出高位
      L = char.charCodeAt(1) // 取出低位
      code = (H - 0xD800) * 0x400 + 0x10000 + L - 0xDC00 // 转换算法
      return "&#" + code + ";"
    } else {
      return char
    }
  })
  return str
}

function uncodeUtf16(str) {
  if (str == null || str == '') {
    return ''
  }
  var reg = /\&#\d+;/g
  return str.replace(reg, function (char) {
    var code = parseInt(char.match(/\d+/)[0], 10)
    if (code < 0x10000) {
      return String.fromCharCode(code)
    }
    var H = Math.floor((code - 0x10000) / 0x400) + 0xD800
    var L = (code - 0x10000) % 0x400 + 0xDC00
    return String.fromCharCode(H, L)
  })
}
// 返回当前日期
function getDate() {
  var day2 = new Date()
  day2.setTime(day2.getTime())
  var c_year = day2.getFullYear(),
    c_month = (day2.getMonth() + 1) < 10 ? '0' + (day2.getMonth() + 1) : (day2.getMonth() + 1),
    c_day = day2.getDate() < 10 ? '0' + day2.getDate() : day2.getDate()

  return c_year + '-' + c_month + '-' + c_day
}
// 返回当前时间 半年前的时间
function getPastHalfYear() {
  // 先获取当前时间
  var curDate = (new Date()).getTime()
  // 将半年的时间单位换算成毫秒
  var halfYear = 365 / 2 * 24 * 3600 * 1000
  var pastResult = curDate - halfYear  // 半年前的时间（毫秒单位）

  // 日期函数，定义起点为半年前
  var pastDate = new Date(pastResult),
    pastYear = pastDate.getFullYear(),
    pastMonth = (pastDate.getMonth() + 1) < 10 ? '0' + (pastDate.getMonth() + 1) : (pastDate.getMonth() + 1),
    pastDay = pastDate.getDate() < 10 ? '0' + pastDate.getDate() : pastDate.getDate()
  return pastYear + '-' + pastMonth + '-' + pastDay
}

export default
  {
    uiDomain,
    localDomain,
    ossDomain,
    matchDomain,
    matchUrl,
    appId,
    wsDomain,
    checkWeiXin,
    compareAsc,
    compareDesc,
    dateFtt,
    showSchoolName,
    filterRole,
    utf16toEntities,
    uncodeUtf16,
    getPastHalfYear,
    getDate,
    Nickname

  }
</script>



// WEBPACK FOOTER //
// src/components/Global.vue